<template>
    <div style="padding:30px">
        <!-- 采购清单 -->
        <div class="my-title">
            采购清单
        </div>
        <!-- 介绍 -->
        <div class="pur_text">
            <span>请填写您所需要的耗材或需要预定的订单</span>
        </div>
        <!-- 文本框 -->
        <div class="put_textarea">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入您需要的耗材/预约订单"
                v-model="textarea"
            >
            </el-input>
        </div>
        <!-- 按钮 -->
        <div class="subpurcha">
            <el-button type='primary' @click="addPurchase">点击提交</el-button>
        </div>
    </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
  import {purchaseAdd} from '@/api/index.js'
export default {
    data() {
        return {
            textarea: ""
        };
    },
    methods:{
    addPurchase(){
        console.log(this.textarea);
        if(this.textarea == ''){
            return this.$message.info('不能为空')
        }
        purchaseAdd({content:this.textarea},header).then(res=>{
        if(res.code !=1){
            return this.$message.error('提交失败')
        }
         return this.$message.success('提交成功')
        })
    }
    }
};
</script>
<style lang="less" scoped>
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.pur_text {
    width: 288px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
    margin-top:29px

}
.put_textarea{
    width: 775px;
    height: 228px;
    margin-top: 17px;
    .el-textarea{
        height: 100%;
       /deep/ .el-textarea__inner{
            height: 228px !important;
        }
    }
}
.subpurcha{
    margin-top: 151px;
    text-align: center;
    margin-bottom: 64px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/purchasingList.vue